import axios from "axios"

//apply base url for axios
const API_URL = process.env.REACT_APP_DATABASEURL || "http://nextgen-dairy.receptumelogic.com/api/public/api/"

const axiosApi = axios.create({
  baseURL: API_URL,
  timeout: 30000, // FIX: 30-second timeout instead of infinite
})

// FIX: Dynamic token from localStorage instead of hardcoded static token
axiosApi.interceptors.request.use(
  config => {
    config._startTime = Date.now()

    // Always get fresh token from localStorage
    try {
      const userData = localStorage.getItem("authUser")
      if (userData) {
        const user = JSON.parse(userData)
        if (user && user.token) {
          config.headers.Authorization = `Bearer ${user.token}`
        }
      }
    } catch (e) {
      console.error("Failed to read auth token:", e)
    }

    return config
  },
  error => Promise.reject(error)
)

axiosApi.interceptors.response.use(
  response => {
    if (response.config._startTime) {
      const elapsed = Date.now() - response.config._startTime
      const icon = elapsed > 1000 ? '🐢' : '✅'
      console.log(`%c${icon} API ✓ ${response.config.url} — ${elapsed}ms [${response.status}]`, `color: ${elapsed > 1000 ? '#ef4444' : '#22c55e'}; font-weight: bold`)
    }
    return response
  },
  error => {
    if (error.config?._startTime) {
      const elapsed = Date.now() - error.config._startTime
      console.error(`%c❌ API ✗ ${error.config?.method?.toUpperCase()} ${error.config?.url} — ${elapsed}ms [${error.response?.status || 'TIMEOUT/NETWORK'}]`, 'color: #ef4444; font-weight: bold')
    }

    // FIX: Handle 401 — redirect to login when token expires
    if (error.response?.status === 401) {
      console.warn("⚠️ Session expired (401) — redirecting to login")
      if (!window.location.pathname.includes('/login')) {
        try { localStorage.removeItem("authUser") } catch (e) { /* ignore */ }
        try { localStorage.removeItem("dairy_role") } catch (e) { /* ignore */ }
        window.location.href = "/login"
      }
      return Promise.reject({ message: "Session expired. Please login again." })
    }

    // FIX: Handle timeout explicitly
    if (error.code === "ECONNABORTED") {
      console.error("⏰ Request timed out — server may be down")
      return Promise.reject({ message: "Request timed out. Please try again." })
    }

    // Handle network error
    if (!error.response) {
      console.error("🔌 Network error — server unreachable")
      return Promise.reject({ message: "Network error. Check your connection." })
    }

    return Promise.reject(error)
  }
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(error => {
      // Extract the actual error message from Laravel's JSON response
      if (error.response && error.response.data) {
        return error.response.data // Return {success: false, message: "..."} so saga can handle it
      }
      throw error
    })
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
